
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="false">
            <a-form-item label="省市">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">审核成功</a-select-option>
                <a-select-option value="2">等待审核</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="场次">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="24">
            <a-form-item label="考试时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator"> 
      <a-upload
          name="file"
          accept=".xlsx"
          action
          :before-upload="beforeUpload"
          style="margin-left: 8px;display: inline-block"
      >
        <a-button>
          上传名单
          <a-icon type="upload"/>
        </a-button>
      </a-upload>
      <a-button @click="downloadTpl">
        下载模板
        <a-icon type="download"/>
      </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.user_name}}
            <br/>
            上传时间 {{record.create_time|timeFormat}}
            <br/>
            <a-tag v-if="record.peixun_name">{{record.peixun_name}}</a-tag>
            <br/>
            注册时间 {{record.today|timeFormat}}
          </div>
      </span>
      <span slot="jindu" slot-scope="text,record">
        人数{{record.membercount}}<br/>
        <a-tag v-if="record.status==2" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.status==1" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        <a v-if="record.resultszip && record.resultszip2">成绩已上传</a>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定审核吗?" @confirm="handleShenhe(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">审核</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.zip_url"/>
          <a v-if="record.zip_url" @click="downloadCert(record)">下载证书</a>
          <a-divider type="vertical" />
          <a @click="handleUserManage(record)">人员管理</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="用户名"
                  hasFeedback
            >
            {{formData.user_name}}
          </a-form-item>
              </a-col>

            </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="审核状态"
                  hasFeedback
          >
            <a-radio-group v-model="formData.status" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="2">待审核</a-radio-button>
              <a-radio-button :value="1">审核通过</a-radio-button>
              <a-radio-button :value="3">审核失败</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>



        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="人员名单"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userVisible"
            @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="userColumns" :dataSource="kaojiUserList" :pagination="userPagination"
                   @change="handleUserTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索姓名"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="userSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="userSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.name}} <br/>
              {{record.code}}
            </span>

            <span slot="action" slot-scope="text,record">
            <template >
              <a @click="handleMemberEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteMemberHandle(record)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="人员操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userFormVisible"
            @ok="handleUserOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="身份证"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>


          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="手机"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'phone',
              {rules: []}
            ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="性别"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sex',
              {rules: []}
            ]"
                          placeholder="请输入性别"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="等级"
                      hasFeedback
              >
                <a-select v-model="userFormData.grade" placeholder="请选择"
                          allowClear >
                  <a-select-option value="初级">初级</a-select-option>
                  <a-select-option value="中级">中级</a-select-option>
                  <a-select-option value="高级">高级</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="注册日期"
                      hasFeedback
              >

                <a-date-picker
                        v-model="userFormData.regist_date_moment"
                        format="YYYY-MM-DD"
                        placeholder="注册日期"/>

              </a-form-item>
            </a-col>


          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="userFormVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserOk">保存</a-button>
      </template>
    </a-modal>
    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量生成"
        v-model="taskInfoShow"
    >
      <a-badge status="success" :text="'生成成功 '+(taskInfo.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'生成失败 '+(taskInfo.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo.urls.length-1) "/>
      </p>
      <a-progress :percent="taskInfo.percent"/>
      </p>
      <div style="height: 300px; overflow:scroll;">
        <p v-for="(error,i) in taskInfo.urls" :key="i">{{ error.name }}</p> 
      </div>
    </a-modal>


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/' 
  import JianduPicker from '@/components/JianduPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
import { doUrlTask } from "@/api/utils";
  import 'moment/locale/zh-cn';
  import XLSX from 'xlsx'
  import setting from "@/config/setting";
import { sjsqOptions } from "@/api/huiyi";

  moment.locale('zh-cn');

  import { peixunshiManageList ,memberImport,manageDetail,editManage ,getApplyMemberList,memberDetail,memberEdit,applyDelete,memberDelete,getShenheUrls} from '@/api/peixunshi'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell, 
      JianduPicker,
    },
    data () {
      return {
        areaOptions,
        userFormVisible: false,
        peixunshiPickerShow: false,
        jianduPickerShow: false,
        userVisible: false,
        visible: false,
        saveLoading:false,
      sjsqOptions: [],
        formData:{
          id:0,
          danwei:'',
          datetitle_moment:null,
          datetitle:'',
          resultszip:[],
          peixunshi:[],
          jiandu:[],
          namekeys:[],
          areas:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form2: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '状态',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],


        //领取人员表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '姓名',
            dataIndex: 'name',
            width:'150px',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '身份证',
            dataIndex: 'num'
          },
          {
            title: '等级',
            width:'100px',
            dataIndex: 'grade',
          },
          {
            title: '注册时间',
            width:'150px',
            dataIndex: 'regist_date',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width:'200px',
            scopedSlots: {
              customRender: 'action',
            }
          },
        ],
        userPagination:{
        },
        userQuery:{
          manageid:0,
          status:0,
          page:1,
          keywords:undefined
        },
        taskInfoShow:false,
        taskInfo: {
          urls: [],
          errors: [],
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          percent: 0,
          doing: false,
        },
        userFormData:{
          id:0,
          regist_date_moment:null,
          regist_date:0,
        },
        kaojiUserList:[],


        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return peixunshiManageList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions() {
        let that = this;
        sjsqOptions({}).then((res) => {
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        manageDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
      deleteHandle(record){
        let self = this
        applyDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      deleteMemberHandle(record){
        let self = this
        memberDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.fetchUserList();
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editManage({
              id:self.formData.id,
              status:self.formData.status,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      handleUserManage(record) {
        let self = this
        self.userQuery.manageid = record.id;
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.page = 1;
        self.fetchUserList();
        this.userVisible = true
      },


      fetchUserList(){
        let self = this
        getApplyMemberList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.kaojiUserList = res.data.list
          self.userPagination.total = res.data.total
        })
      },

      userSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchUserList();
      },
      userSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.userQuery.keywords = undefined;
        self.fetchUserList();
      },
      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.grade){
          that.userQuery.grade = filters.grade[0];
        }else{
          that.userQuery.grade = '';
        }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.userQuery.page = pagination.current;
        that.fetchUserList();
      },


      handleMemberEdit(record){
        let self = this
        this.userFormVisible = true
        memberDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            res.data.regist_date_moment = moment(res.data.regist_date*1000);
            self.form2.setFieldsValue({ ...res.data })
            self.userFormData.id = record.id;
            console.log('handleEdit')
            self.userFormData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },

      handleUserOk(e){
        let self = this;
        e.preventDefault()
        this.form2.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            self.saveLoading = true;

            memberEdit({
              id:self.userFormData.id,
              name:values.name,
              num:values.num,
              sex:values.sex,
              phone:values.phone,
              grade:self.userFormData.grade,
              regist_date:self.userFormData.regist_date_moment.format('YYYY-MM-DD')
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchUserList();
              self.userFormVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })

          }
        })
      },
      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },


    downloadTpl() {
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1664175762968-3/%E5%9F%B9%E8%AE%AD%E5%B8%88%E5%90%8D%E5%8D%95.xlsx.xlsx')
    },
    beforeUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)

      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log('this.xlsxJson', tabJson);
          let userList = [];
          tabJson[0].sheet.map((item, index) => {
            if (index > 1 && item.__EMPTY_3) { 
              let grade = '';
              if (item.__EMPTY_5) {
                grade = '初级'
              } else if (item.__EMPTY_6) {
                grade = '中级'
              } else if (item.__EMPTY_7) {
                grade = '高级'
              } 
              if(!grade){ 
                that.$message.error(item.__EMPTY_1+'('+item.__EMPTY_3 +')'+'没有填写等级')
                return ;
              }
              userList.push({ 
                namekey: item.__EMPTY,
                name: item.__EMPTY_1,
                sex: item.__EMPTY_2 || '', 
                num: item.__EMPTY_3 || '', 
                phone: item.__EMPTY_4 || '', 
                grade: grade, 
              });
            }

          })

          console.log('userList', userList);

          // return ;

          let that = this; 
          const hide = this.$message.loading("上传中，请稍等..", 0);  
              memberImport({
                list: JSON.stringify(userList),
                peixun_id: that.queryParam.sjsq[1],
              }).then(res => { 
                that.$message.success("上传成功");  
                that.$refs.table.refresh(true)
                setTimeout(hide, 0); 
              })
              .catch(err => {
                that.$message.error(err.data.msg)
                setTimeout(hide, 0); 
              });

          return;

          that.taskInfo = {
            members: userList,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            errors: [],
            doing: true,
          }
          // that.taskInfoShow = true;
          that.doTask(that.taskInfo);

        }
      });

      /*
      expressImport(formdata)
        .then(res => {
          that.$message.success('上传成功')
          that.$refs.table.refresh(true)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })*/
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = function (e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file) // 传统input方法
      })
    },


    handleShenhe(record) {
      let that = this;
      this.taskInfoShow = true;
      getShenheUrls({
        id: record.id,
      })
        .then((res) => {
          that.taskInfo = {
            urls: res.data,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            doing: true,
          };
          that.doTask(that.taskInfo);
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },
    doTask(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.urls.length) {
        taskInfo.doing = false;
        that.taskInfoShow = false;
        that.$refs.table.refresh();
        return false;
      }
      doUrlTask({
        url: taskInfo.urls[taskInfo.currentIndex],
      })
        .then((res) => {
          taskInfo.scount++;
          taskInfo.currentIndex++;
          console.log(taskInfo.currentIndex);
          if (taskInfo.currentIndex == taskInfo.urls.length) {
          }
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.urls.length) *
            100
          ).toFixed(1);
          that.doTask(taskInfo);
        })
        .catch((err) => {
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.urls.length) *
            100
          ).toFixed(1);
          that.doTask(taskInfo);
        });
    },
    downloadCert(record) {
      window.open(setting.apiBaseURL + "" + record.zip_url);
    },

    },
    filters:{
    },
    watch: {
    }
  }
</script>


<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
